import { createContext, useContext } from 'react'

/**
 * Sprache und Kapitelsprünge für die Use-Case-Stories.
 * Die Sprache steht in ?lang=, so lässt sich ein Link direkt auf Englisch teilen.
 */

export const LANGS = ['de', 'en']

export const readParam = (key) =>
  new URLSearchParams(window.location.search).get(key)

export const writeParam = (key, value) => {
  const url = new URL(window.location.href)
  if (value) url.searchParams.set(key, value)
  else url.searchParams.delete(key)
  window.history.replaceState(null, '', url)
}

export const readLang = () => {
  const lang = readParam('lang')
  return LANGS.includes(lang) ? lang : 'de'
}

const StoryContext = createContext({
  lang: 'de',
  copy: {},
  goTo: () => {},
  theme: 'dark'
})

export const StoryProvider = StoryContext.Provider

/** Copy der aktuellen Sprache, optional nur ein Teilbereich. */
export const useCopy = (part) => {
  const { copy } = useContext(StoryContext)
  return part ? copy[part] : copy
}

export const useLang = () => useContext(StoryContext).lang

/** Theme der Showcase-Versionen (dark oder light). */
export const useTheme = () => useContext(StoryContext).theme ?? 'dark'

/** Springt zu einem Kapitel per id. */
export const useGoTo = () => useContext(StoryContext).goTo
